export default __webpack_public_path__ + "static/media/se-plc.6a4af437.png";